import React, {useState} from 'react';
import Exceptional_by_design from './imgs/header_pic_only.jpg';
import textura_27 from './imgs/demo1.webp';
import textura_55 from './imgs/demo2.webp';
import textura_33 from './imgs/demo3.webp';
import contactImage from '../ProCaseStudy/img/Employee 1.png';
import useWindowResize from '../../apps/Hooks/useWindowResize';

const PRODUCT_CARDS = [
    {
        title: '27” Textura Pro Digital Canvas',
        image: textura_27,
        link: '/pro/textura-pro-27',
        colors: [
            {fill: '#DBC28C'},
            {fill: '#FFFFFF', border: '#111111'},
            {fill: '#886645'},
            {fill: '#191919'}
        ]
    },
    {
        title: '55” 4K Textura Pro Digital Canvas',
        image: textura_55,
        link: '/pro/textura-pro-55',
        badge: 'NEW',
        colors: [
            {fill: '#191919'},
            {fill: '#886645'}
        ]
    },
    {
        title: '33” Square Textura Pro Digital Canvas',
        image: textura_33,
        link: '/pro/textura-pro-33',
        badge: 'COMING SOON',
        muted: true,
        disabled: true
    }
];

const styles = {
    section: {
        background: '#ffffff',
        padding: '60px 0 88px'
    },
    inner: {
        width: '82vw',
        margin: '0 auto',
        fontFamily: 'proxima-nova, sans-serif',
        color: '#000000'
    },
    hero: {
        position: 'relative',
        minHeight: '634px',
        borderRadius: '20px',
        overflow: 'hidden',
        background: '#000000'
    },
    heroImage: {
        width: '100%',
        height: '100%',
        minHeight: '634px',
        objectFit: 'cover',
        display: 'block'
    },
    heroOverlay: {
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(90deg, rgba(0, 0, 0, 0.66) 0%, rgba(0, 0, 0, 0.28) 18%, rgba(0, 0, 0, 0) 42%)'
    },
    heroCopy: {
        position: 'absolute',
        left: '38px',
        bottom: '34px',
        zIndex: 1,
        color: '#ffffff'
    },
    heroTitle: {
        margin: 0,
        fontFamily: 'proxima-nova, sans-serif',
        fontSize: '48px',
        fontWeight: 700,
        lineHeight: 1
    },
    heroSubtitle: {
        margin: '6px 0 0',
        fontSize: '32px',
        lineHeight: 1.1
    },
    headline: {
        maxWidth: '1114px',
        margin: '88px auto 66px',
        textAlign: 'center',
        fontSize: '32px',
        lineHeight: 1.35
    },
    products: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gap: '24px'
    },
    productCard: {
        minHeight: '547px',
        padding: '24px 25px 18px',
        borderRadius: '23px',
        background: '#f5f7f8',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
        overflow: 'hidden'
    },
    productCardDisabled: {
        cursor: 'default'
    },
    productCardMuted: {
        opacity: 0.3
    },
    productHeader: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: '16px',
        minHeight: '50px'
    },
    productTitle: {
        margin: 0,
        fontSize: '24px',
        fontWeight: 400,
        lineHeight: 1.2
    },
    badge: {
        flexShrink: 0,
        borderRadius: '7px',
        background: '#ffffff',
        padding: '6px 20px',
        fontFamily: 'proxima-nova, sans-serif',
        fontSize: '20px',
        fontWeight: 600,
        lineHeight: 1,
        whiteSpace: 'nowrap'
    },
    productImageWrap: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '12px 0 8px',
        overflow: 'hidden'
    },
    productImage: {
        maxWidth: '100%',
        maxHeight: '390px',
        objectFit: 'contain',
        display: 'block',
        transition: 'transform 0.28s ease'
    },
    swatches: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '12px',
        minHeight: '24px'
    },
    swatchesEmpty: {
        visibility: 'hidden'
    },
    swatchLabel: {
        fontSize: '11px',
        lineHeight: 1,
        letterSpacing: '0.03em'
    },
    swatchList: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
    },
    swatch: {
        width: '14px',
        height: '14px',
        borderRadius: '50%',
        border: '1px solid transparent',
        boxSizing: 'border-box'
    },
    contactWrap: {
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'stretch',
        flexDirection: 'row'
    },
    contactPanel: {
        borderRadius: '20px',
        background: 'rgba(42, 150, 21, 0.08)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start'
    },
    contactText: {
        margin: 0,
        fontFamily: 'proxima-nova, sans-serif',
        fontSize: '2rem',
        lineHeight: 1.2,
        color: '#000000'
    },
    contactButton: {
        width: '12.6vw',
        minWidth: '220px',
        marginTop: '-1vh',
        fontSize: '1rem',
        fontWeight: 'bold',
        color: 'white',
        backgroundColor: '#FFFFFF',
        border: '0.125rem solid black',
        borderRadius: '0.313rem',
        cursor: 'pointer',
        textAlign: 'center',
        padding: '0.75rem 2.25rem',
        boxShadow: 'inset 0 0 0 0 #000000',
        transition: 'ease-out 0.4s'
    },
    contactButtonLabel: {
        color: 'black',
        fontFamily: 'proxima-nova, sans-serif'
    },
    contactImage: {
        display: 'block',
        objectFit: 'cover',
        borderRadius: '20px'
    }
};

const ProCommodity = () => {
    const {windowWidth} = useWindowResize();
    const [hoveredCard, setHoveredCard] = useState(null);
    const isMobile = windowWidth <= 767;
    const isTablet = windowWidth <= 1200;

    const sectionStyle = {
        ...styles.section,
        padding: isMobile ? '32px 0 56px' : styles.section.padding
    };

    const innerStyle = {
        ...styles.inner,
        width: isMobile ? 'calc(100vw - 32px)' : styles.inner.width
    };

    const heroStyle = {
        ...styles.hero,
        minHeight: isMobile ? '360px' : isTablet ? '520px' : styles.hero.minHeight
    };

    const heroImageStyle = {
        ...styles.heroImage,
        minHeight: isMobile ? '360px' : isTablet ? '520px' : styles.heroImage.minHeight
    };

    const heroOverlayStyle = {
        ...styles.heroOverlay,
        background: isMobile
            ? 'linear-gradient(180deg, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0.65) 100%)'
            : styles.heroOverlay.background
    };

    const heroCopyStyle = {
        ...styles.heroCopy,
        left: isMobile ? '20px' : styles.heroCopy.left,
        right: isMobile ? '20px' : 'auto',
        bottom: isMobile ? '20px' : styles.heroCopy.bottom
    };

    const heroTitleStyle = {
        ...styles.heroTitle,
        fontSize: isMobile ? '32px' : isTablet ? '40px' : styles.heroTitle.fontSize
    };

    const heroSubtitleStyle = {
        ...styles.heroSubtitle,
        fontSize: isMobile ? '22px' : isTablet ? '26px' : styles.heroSubtitle.fontSize
    };

    const headlineStyle = {
        ...styles.headline,
        margin: isMobile ? '32px auto 28px' : isTablet ? '56px auto 42px' : styles.headline.margin,
        fontSize: isMobile ? '22px' : isTablet ? '26px' : styles.headline.fontSize
    };

    const productsStyle = {
        ...styles.products,
        gridTemplateColumns: isTablet ? '1fr' : styles.products.gridTemplateColumns
    };

    const productCardStyle = {
        ...styles.productCard,
        minHeight: isTablet ? '0' : styles.productCard.minHeight,
        padding: isMobile ? '20px 18px 18px' : styles.productCard.padding
    };

    const productHeaderStyle = {
        ...styles.productHeader,
        minHeight: isMobile ? '0' : styles.productHeader.minHeight,
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? '10px' : styles.productHeader.gap
    };

    const productTitleStyle = {
        ...styles.productTitle,
        fontSize: isMobile ? '20px' : styles.productTitle.fontSize
    };

    const badgeStyle = {
        ...styles.badge,
        fontSize: isMobile ? '14px' : styles.badge.fontSize,
        padding: isMobile ? '6px 12px' : styles.badge.padding
    };

    const productImageStyle = {
        ...styles.productImage,
        maxHeight: isMobile ? '300px' : isTablet ? '340px' : styles.productImage.maxHeight
    };

    const handleCardNavigation = (link) => {
        window.location.href = link;
    };

    const swatchesStyle = {
        ...styles.swatches,
        flexWrap: isMobile ? 'wrap' : 'nowrap'
    };

    const contactWrapStyle = {
        ...styles.contactWrap,
        margin: isMobile ? '28px auto 0' : '40px auto 0',
        flexDirection: isTablet ? 'column' : 'row'
    };

    const contactPanelStyle = {
        ...styles.contactPanel,
        width: isTablet ? '100%' : '40vw',
        minHeight: isTablet ? '240px' : '317px',
        marginLeft: isTablet ? '0' : '-1vw',
        paddingLeft: isTablet ? '20px' : '4vw',
        paddingRight: isTablet ? '20px' : '0',
        gap: '25px'
    };

    const contactTextStyle = {
        ...styles.contactText,
        width: isTablet ? '75vw' : '22vw',
        maxWidth: isTablet ? '100%' : 'none',
        fontSize: isMobile ? '1.75rem' : '1.6rem'
    };

    const contactButtonStyle = {
        ...styles.contactButton,
        width: isTablet ? '100%' : styles.contactButton.width,
        maxWidth: isTablet ? '260px' : 'none',
        minWidth: isTablet ? '0' : styles.contactButton.minWidth,
        marginTop: isTablet ? '20px' : styles.contactButton.marginTop
    };

    const contactImageStyle = {
        ...styles.contactImage,
        width: isTablet ? '100%' : '40vw',
        height: isTablet ? 'auto' : '317px',
        marginLeft: isTablet ? '0' : '1vw',
        marginTop: isTablet ? '1vh' : '0'
    };

    const sectionHeadStyle = {
        marginTop: '40px',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        height: isMobile ? 'auto' : '600px',
        minHeight: isMobile ? '0' : '600px',
        alignItems: 'center',
        borderRadius: '20px',
        overflow: 'hidden'
    };

    const sectionHeadTextPanelStyle = {
        width: isMobile ? '100%' : '450px',
        minWidth: isMobile ? '0' : '450px',
        height: isMobile ? '220px' : '100%',
        backgroundColor: 'black',
        color: 'white',
        order: isMobile ? 2 : 1
    };

    const sectionHeadTextInnerStyle = {
        display: 'flex',
        flexDirection: 'column',
        padding: isMobile ? '24px 20px' : '40px',
        height: '100%',
        justifyContent: 'flex-end'
    };

    const sectionHeadTitleStyle = {
        fontSize: isMobile ? '2rem' : '2.5rem',
        fontWeight: '600',
        lineHeight: 1.05
    };

    const sectionHeadSubtitleStyle = {
        fontSize: isMobile ? '1.125rem' : '1.5rem',
        lineHeight: 1.2,
        marginTop: isMobile ? '6px' : 0
    };

    const sectionHeadImageWrapStyle = {
        flex: 1,
        width: isMobile ? '100%' : 'auto',
        height: isMobile ? '320px' : '100%',
        overflow: 'hidden',
        order: isMobile ? 1 : 2
    };

    const sectionHeadImageStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block'
    };

    return (
        <section style={sectionStyle}>
            <div style={innerStyle}>
                
                <div key={"section-head"} style={sectionHeadStyle}>
                    <div style={sectionHeadTextPanelStyle}>
                        <div style={sectionHeadTextInnerStyle}>
                            <div style={sectionHeadTitleStyle}>
                                Textura Pro
                            </div>
                            <div style={sectionHeadSubtitleStyle}>
                                Exceptional by Design
                            </div>
                        </div>
                    </div>
                    <div style={sectionHeadImageWrapStyle}>
                        <img
                            src={Exceptional_by_design}
                            alt="Textura Pro displayed in a hospitality setting"
                            style={sectionHeadImageStyle}
                        />
                    </div>
                </div>

                <p style={headlineStyle}>
                    Transforming business spaces with seamless art and cutting-edge technology
                </p>

                <div style={productsStyle}>
                    {PRODUCT_CARDS.map((product) => (
                        <article
                            key={product.title}
                            style={product.disabled ? {...productCardStyle, ...styles.productCardDisabled} : productCardStyle}
                            role={product.disabled ? undefined : 'button'}
                            tabIndex={product.disabled ? undefined : 0}
                            onClick={product.disabled ? undefined : () => handleCardNavigation(product.link)}
                            onKeyDown={product.disabled ? undefined : (event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    event.preventDefault();
                                    handleCardNavigation(product.link);
                                }
                            }}
                            onMouseEnter={product.disabled ? undefined : () => setHoveredCard(product.title)}
                            onMouseLeave={() => setHoveredCard(null)}
                        >
                            <div style={product.muted ? {...productHeaderStyle, ...styles.productCardMuted} : productHeaderStyle}>
                                <h2 style={productTitleStyle}>{product.title}</h2>
                                {product.badge ? (
                                    <span style={product.muted ? {...badgeStyle, ...styles.productCardMuted} : badgeStyle}>
                                        {product.badge}
                                    </span>
                                ) : null}
                            </div>

                            <div style={product.muted ? {...styles.productImageWrap, ...styles.productCardMuted} : styles.productImageWrap}>
                                <img
                                    src={product.image}
                                    alt={product.title}
                                    style={{
                                        ...productImageStyle,
                                        transform: !product.disabled && hoveredCard === product.title ? 'scale(1.1)' : 'scale(1)'
                                    }}
                                />
                            </div>

                            {product.colors ? (
                                <div style={swatchesStyle}>
                                    <span style={styles.swatchLabel}>AVAILABLE IN</span>
                                    <div style={styles.swatchList}>
                                        {product.colors.map((color, index) => (
                                            <span
                                                key={`${product.title}-${index}`}
                                                style={{
                                                    ...styles.swatch,
                                                    backgroundColor: color.fill,
                                                    borderColor: color.border ?? 'transparent'
                                                }}
                                            />
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <div style={{...swatchesStyle, ...styles.swatchesEmpty}}/>
                            )}
                        </article>
                    ))}
                </div>
                <div style={contactWrapStyle}>
                    <div style={contactPanelStyle}>
                        <p style={contactTextStyle}>
                            Ready to redefine art and business with Vieunite Pro?
                        </p>
                        <button
                            type="button"
                            style={contactButtonStyle}
                            onClick={() => {
                                window.location.href = '/pro/support/request-demo';
                            }}
                            onMouseEnter={(event) => {
                                event.currentTarget.style.boxShadow = 'inset 62.5rem 0 0 0 #000000';
                                event.currentTarget.querySelector('span').style.color = 'white';
                            }}
                            onMouseLeave={(event) => {
                                event.currentTarget.style.boxShadow = 'inset 0 0 0 0 #000000';
                                event.currentTarget.querySelector('span').style.color = 'black';
                            }}
                        >
                            <span style={styles.contactButtonLabel}>CONTACT US</span>
                        </button>
                    </div>
                    <img
                        src={contactImage}
                        alt="Vieunite Pro in a workplace setting"
                        style={contactImageStyle}
                    />
                </div>

            </div>
        </section>
    );
};

export default ProCommodity;
